import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { EventService } from '../../shared/services/event.service';
import { ToastrService } from "ngx-toastr";

@Component({
  selector: 'ps-view-published-features',
  templateUrl: './view-published-features.component.html',
  styleUrls: ['./view-published-features.component.scss']
})
export class ViewPublishedFeaturesComponent {
  public events: any;
  public eventData!: any[];
  public eventId: any;
  public date: any;
  public addbutton!: boolean;
  public activeTab: any;
  public role: any
  public url!: any[];
  public institutioncomponentRouting: any = []
  public institutionCurrentComponent: any;
  public imageUrl!: any[];
  public titleForm: any;
  public summarForm: any;
  public instituteId: any;
  public eventList!: any[];
  public eventdetail: any;
  public text: any;
  public published!: boolean;
  public step: boolean = false;
  public step1: boolean = false;
  public institutionDetails: any;
  public institutionName: any;
  public openNav: boolean = false;
  public data1!: any[];
  public hidePrevious!: boolean;
  public examLength!: boolean;
  public pageLength: any = [];
  public selectedIndex: any;
  public noModule: boolean = false;
  public isDeleted!: boolean;
  public deleteId: any;
  public pageCount: any = [];
  public error: boolean = false;
  public currentPage: number = 1;
  public totalPages: number = 0;
  public count!: number;
  public startIndex!: number;
  public endIndex!: number;
  public page = 1;
  public showPageType = [
    { "id": 9, "value": 'Show 9 Per Page' },
    { "id": 18, "value": 'Show 18 Per Page' },
    { "id": 27, "value": 'Show 27 Per Page' },
    { "id": 45, "value": 'Show 45 Per Page' },
    { "id": 90, "value": 'Show 90 Per Page' }];
  public pageValue: number = 9;
  public pagebutton: boolean = false;
  public searchPage!: number | null;
  public isPageAvailable!: boolean;
  public pages: any[] = []
  public spinner!: boolean;


  constructor(private router: Router, private EventService: EventService, private toastr: ToastrService) { }

  ngOnInit(): void {
    this.getAllEventsInstitution();
  }

  openMobileNav() {
    this.openNav = !this.openNav;
  }

  //format date
  formatDate(date: any) {
    var d = new Date(date),
      month = '' + (d.getMonth() + 1),
      day = '' + d.getDate(),
      year = d.getFullYear();
    if (month.length < 2)
      month = '0' + month;
    if (day.length < 2)
      day = '0' + day;
    return [day, month, year].join('-');
  }

  // getAllInstitutionEvents
  getAllInstitutionEvents(id: any) {
    var id = this.instituteId
    this.eventList = [];
    this.EventService.getAllInstitutionEvents(id).subscribe(res => {
      if (res.status) {
        this.eventdetail = res.data
        this.eventdetail.sort((a: any, b: any) => a.order - b.order);
        this.eventdetail.forEach((ele: any) => {
          this.text = ele.eventText
          var temp = {
            documentID: ele.coverImage
          }
          this.EventService.getImagePresignedUrl(temp).subscribe(res => {
            if (res.status) {
              this.eventList.push({
                _id: ele._id,
                title: ele.title,
                image: res.data,
                status: ele.isAssigned,
                isApporovedBySPOC: ele.isApporovedBySPOC
              })
            }
          })
          this.eventList.sort((a, b) => a.order - b.order);
        })
      }
    })
    if (this.eventList.length == 0) {
      this.addbutton = true
    }
    else {
      this.addbutton = false
    }
  }

  // getAllEventsInstitution
  getAllEventsInstitution() {
    var data = {
      "page": this.currentPage,
      "itemsPerPage": this.pageValue
    }
    this.eventData = []
    this.EventService.getAllEventsInstitution(data).subscribe(res => {
      if (res.status) {
        this.spinner = true
        this.events = res.data
        this.eventId = res.data._id
        this.events.forEach((item: any) => {
          if (res.status) {
            this.eventData.push({
              date: this.formatDate(item.createdAt),
              _id: item._id,
              institutionName: item.institutionName,
              eventText: item.eventText,
              image: item.urlArray[0].url,
              title: item.title
            })
          }
        })
        this.isPageAvailable = false;
        this.count = res?.count
        this.pagesArray(this.currentPage, this.count, this.pageValue, 5)
        this.calculateTotalPages()
        this.setPaginatedData()
        if (res.data.length == 0) {
          this.error = true;
        }
        else {
          this.error = false;
        }
      }
      else {
        this.error = true;
        this.spinner = true;
        this.toastr.error("No Feauture Recommended here");
      }
    })

  }

  // Calculate total pages for pagination
  calculateTotalPages() {
    this.totalPages = Math.ceil(this.count / this.pageValue);
  }

  // set Pagination data for 
  setPaginatedData() {
    this.startIndex = (this.currentPage - 1) * this.pageValue;
    this.endIndex = Math.min(this.startIndex + this.pageValue, this.count);
  }

  // go to page function
  goToPage(page: number) {
    this.currentPage = page;
    this.getAllEventsInstitution();
    this.calculateTotalPages();
    this.searchPage = null;
    this.setPaginatedData();
    this.isPageAvailable = false;
  }

  //  net page function
  nextPage() {
    if (this.currentPage < this.totalPages) {
      this.currentPage++;
      this.setPaginatedData();
      this.searchPage = null;
      this.getAllEventsInstitution();
    }
  }

  // previous function
  previousPage() {
    if (this.currentPage > 1) {
      this.currentPage--;
      this.setPaginatedData();
      this.searchPage = null;
      this.getAllEventsInstitution()
    }
  }

  // onChangePagination function
  onChangePagination(event: any) {
    this.pageValue = parseInt(event.target.value)
    this.currentPage = 1;
    this.searchPage = null;
    this.getAllEventsInstitution();
    if (this.pageValue > this.count) {
      this.pagebutton = true
      this.searchPage = null;
      this.isPageAvailable = false;
    }
    else {
      this.pagebutton = false;
      this.isPageAvailable = true;
    }
  }

  //Pages Array
  pagesArray(currentPage: number, collectionLength: number, rowsPerPage: number, paginationRange: number) {
    var pages = [];
    var totalPages = Math.ceil(collectionLength / rowsPerPage);
    var halfWay = Math.ceil(paginationRange / 2);
    var position;

    if (currentPage <= halfWay) {
      position = 'start';
    } else if (totalPages - halfWay < currentPage) {
      position = 'end';
    } else {
      position = 'middle';
    }
    var ellipsesNeeded = paginationRange < totalPages;
    var i = 1;
    while (i <= totalPages && i <= paginationRange) {
      var pageNumber = this.calculatePageNumber(i, currentPage, paginationRange, totalPages);
      var openingEllipsesNeeded = (i === 2 && (position === 'middle' || position === 'end'));
      var closingEllipsesNeeded = (i === paginationRange - 1 && (position === 'middle' || position === 'start'));
      if (ellipsesNeeded && (openingEllipsesNeeded || closingEllipsesNeeded)) {
        pages.push('...');
      } else {
        pages.push(pageNumber);
      }
      i++;
    }
    this.pages = pages
  }

  //calculate page Number
  calculatePageNumber(i: number, currentPage: number, paginationRange: number, totalPages: number): number {
    let halfWay = Math.ceil(paginationRange / 2);
    if (i === paginationRange) {
      return totalPages;
    } else if (i === 1) {
      return i;
    } else if (paginationRange < totalPages) {
      if (totalPages - halfWay < currentPage) {
        return totalPages - paginationRange + i;
      } else if (halfWay < currentPage) {
        return currentPage - halfWay + i;
      } else {
        return i;
      }
    } else {
      return i;
    }
  }

  // SearchPage Function
  searchPageno() {
    const value = this.searchPage;
    if (value !== null && value > 0 && this.totalPages >= value) {
      this.isPageAvailable = false;
      this.currentPage = value;
      this.getAllEventsInstitution();
    }
    else {
      this.isPageAvailable = true;
    }
  }


  // check event
  checkEvent(id: any) {
    this.eventId = id
    this.router.navigate(["/auth/sharedArticle/" + this.eventId]);
  }


}
